import { TinyMCECommonOptions, TinyMCEDynamicOptions } from 'jamespot-user-api';

export const initTinyMCEOptions = (dynamicOptions: TinyMCEDynamicOptions): TinyMCECommonOptions => ({
    ...dynamicOptions,
    promotion: false,
    height: 500,
    menubar: false,
    toolbar_mode: 'sliding',
    plugins: [
        'autolink',
        'lists',
        'advlist',
        'link',
        'image',
        'charmap',
        'wordcount',
        'fullscreen',
        'code',
        'media',
        'table',
        'emoticons',
        'codesample',
        'quickbars',
    ],
    text_patterns: [],
    convert_urls: false,
    invalid_elements:
        'body,html,head,title,script,meta,link,style,applet,form,input,select,textarea,div,' +
        'section,header,nav,article,footer,aside,button',
    extended_valid_elements: 'j-mention',
    custom_elements: '~j-mention',
    inline_boundaries_selector: 'j-mention',
    skin: 'jamespot',
    branding: false,
    font_size_formats: '10px 12px 14px 16px 18px 24px 32px',
    contextmenu: false,
    paste_data_images: false,
    browser_spellcheck: true,
    quickbars_insert_toolbar: false,
    license_key: 'gpl',
});

export const tinyMCEOptions_mock: TinyMCECommonOptions = initTinyMCEOptions({
    cache_suffix: '?v=1',
    toolbar:
        'blocks fontsize forecolor bold italic underline strikethrough alignleft ' +
        'aligncenter alignright image bullist numlist link unlink emoticons',
    language: 'fr_FR',
    content_css: 'https://ecosysteme.jamespot.pro/css/tinymce.php',
    quickbars_selection_toolbar: '',
});
